import EventManager from '../EventManager.js'

/**
 * 所有H5可视组件的基类
 * @constructor
 * @param options 构造参数
 */
export default class VisibleComponent {
  // 标识当前组件是否已经被 show
  hasShown = true
  // 初始化事件管理器
  eventManager = new EventManager()

  constructor(options = {}) {
  }

  init() {
    if(this.template){
      this.element = this._parseHTML(this.template)
      // 绑定事件到this.element上
      this.bindVisibleComponentEvent()
    }
  }

  _parseHTML(HTMLString) {
    const templateWrap = document.createElement('div')
    templateWrap.innerHTML = HTMLString
    return templateWrap.firstElementChild
  }

  bindVisibleComponentEvent() {
    ['click', 'dblclick'].forEach((evName) => {
      this.element.addEventListener(evName, (e) => {
        this.eventManager.fireEvent(evName, e)
      })
    })
  }

  addClass(target, classes) {
    let classList = []
    if (typeof classes === 'string') {
      classList = classes.split(' ')
    } else if (Array.isArray(classes)) {
      classList = classes
    }
    classList.forEach(item => {
      target.classList.add(item)
    })
  }

  //*****************************************--方法--******************************************//

  /**
   *
   * @param params
   * @returns {*|Promise<any>}
   */
  /*
  getViewInfo(params) {
      const _params = this.getInvokeParams(params)
      return operateComponentAPI.getViewInfo(_params)
  }*/

  /*
  setViewInfo(params) {
      const _params = this.getInvokeParams(params)
      return operateComponentAPI.setViewInfo(_params)
  }*/

  setText(text) {
    this.element.textContent = text
  }

  destory() {
    this.element.parentNode.removeChild(this.element)
  }

  /**
   * 设置视图定位宽高
   * @param params
   * @returns {*|Promise<any>}
   */

  setRect(params) {
    //console.log('设置视图定位宽高:', params)
    //const _params = this.getInvokeParams({rect:params})
    //return operateComponentAPI.setViewRect(_params)
  }


  /**
   * 移动当前组件到父视图的顶部 暂不支持
   * @param params
   * @returns {*|Promise<any>}
   */

  toFront(params) {
  }

  /**
   * 在当前组件上添加其他组件
   * @param params
   * @returns {*|Promise<any>}
   */
  append(sub, rect) {
    return new Promise(resolve => {
      this.element.appendChild(sub.element)
      resolve()
    })
  }

  /**
   * 将当前组件添加到指定组件上
   * @param params
   * @returns {*|Promise<any>}
   */
  appendTo(target) {
    return new Promise(resolve => {
      if (target instanceof HTMLElement) {
        target.appendChild(this.element)
      } else if (target instanceof VisibleComponent) {
        target.element.appendChild(this.element)
      }
      resolve()
    })
  }

  /**
   * 从父视图移除自身
   * @param params
   * @returns {*|Promise<any>}
   */
  removeSelf() {
    return new Promise(resolve => {
      this.element &&
      this.element.parentNode &&
      this.element.parentNode.removeChild(this.element)
      resolve()
    })
  }

  /**
   * 隐藏组件
   * @param params
   * @returns {*|Promise<any>}
   */
  hide() {
    // if (!this.hasShown) {
    //     console.log('组件已被隐藏，不再重复 hide')
    //     return
    // }
    if (this.element.style.display != 'none') {
      this.element.display = this.element.style.display
    }
    this.element.style.display = 'none'
    this.hasShown = false
    console.log('element hide: ', this.element)
  }

  /**
   * 显示组件
   * @param params
   * @returns {*|Promise<any>}
   */
  show() {
    // if (this.hasShown) {
    //     console.log('组件已被展示，不再重复 show')
    //     return
    // }
    this.element.style.display = this.element.display || 'block'
    this.hasShown = true
    console.log('element show: ', this.element)
    this.eventManager.fireEvent('show')
  }

  /**
   * 设置背景
   * @param params
   * @returns {*|Promise<any>}
   */
  setBG(params) {
    this.element.style.backgroundColor = params
  }

  /**
   * 设置透明度
   * @param alpha  透明度值：0 ～ 1.0
   * @returns {*|Promise<any>}
   */
  setAlpha(alpha) {
    this.element.style.opacity = alpha
  }

  /**
   * 设置缩放
   * @param params 暂未实现
   * @returns {*|Promise<any>}
   */
  setScale(params) {
  }

  /**
   * 插入到target组件层级的上方
   * @param params
   * @returns {*|Promise<any>}
   */
  insertAboveTo(target, rect) {
    target.parentNode.appendChild(this.element)
    this.element.style.zIndex = (target.parentNode.style.zIndex || 0) + 1
  }

  /**
   * 插入到target组件层级的下方
   * @param params
   * @returns {*|Promise<any>}
   */
  insertBelowTo(target, rect) {
    target.parentNode.appendChild(this.element)
    this.element.style.zIndex = (target.parentNode.style.zIndex || 0) - 1
  }

  getInstance() {
    return this.element
  }

  //*****************************************--事件--******************************************//
  /**
   * 组件被点击时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */
  onClick(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('click', cb)
  }

  /**
   * 组件被双击时触发（SDK暂未实现）
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onDoubleClick(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('dblclick', cb)
  }

  /**
   * 设置视图时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onRectChanged(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onViewRectChanged(this.getId(), cb)
  }

  /**
   * 被从父视图移除时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onRemoveSelf(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onRemoveFromView(this.getId(), cb)
  }

  /**
   * 在当前视图上添加其他视图时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onAppend(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onAppendView(this.getId(), cb)
  }

  /**
   * 将当前视图添加到指定视图上时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onAppendTo(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onAppendViewTo(this.getId(), cb)
  }

  /**
   * 当前视图层级被置顶时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onBringToFront(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onBringViewToFront(this.getId(), cb)
  }

  /**
   * 隐藏组件时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onHide(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onHideView(this.getId(), cb)
  }

  /**
   * 显示组件时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onShow(cb) {
    'function' === typeof cb && this.eventManager.addEventListener('show', cb)
  }

  /**
   * 背景颜色改变时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onBgColorChanged(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onViewBgColorChanged(this.getId(), cb)
  }

  /**
   * 透明度改变时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onAlphaChanged(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onViewAlphaChanged(this.getId(), cb)
  }

  /**
   * 组件缩放改变时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onScaleChanged(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onViewScaleChanged(this.getId(), cb)
  }


  /**
   * 将组件添加到目标组件的上层时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onInsertAbove(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onInsertViewAbove(this.getId(), cb)
  }

  /**
   * 将组件添加到目标组件的下层时触发
   * @param cb | Function
   * @returns {*|Promise<any>}
   */

  onInsertBelow(cb) {
    'function' === typeof cb &&
    nativeComponentListener.onInsertViewBelow(this.getId(), cb)
  }

  toggleDisplayStatus() {
    if (this.hasShown) {
      this.hide()
    } else {
      this.show()
    }
  }
}
